export type ConfidenceBucket = 'high' | 'medium' | 'low';
export type BinaryConfidenceBucket = 'high' | 'low';
export type ConfidenceDisplayMode = '3bucket' | 'binary';

const STORAGE_KEY = 'confidence_display_mode';

export function deriveBinaryBucket(
  bucket: ConfidenceBucket | string | null | undefined,
): BinaryConfidenceBucket | null {
  if (bucket === null || bucket === undefined) return null;
  return bucket === 'high' ? 'high' : 'low';
}

function readEnvDefault(): ConfidenceDisplayMode {
  const raw = (import.meta.env.VITE_CONFIDENCE_BINARY_BADGE ?? '')
    .toString()
    .toLowerCase();
  return raw === 'true' || raw === '1' || raw === 'on' ? 'binary' : '3bucket';
}

export function getConfidenceDisplayMode(): ConfidenceDisplayMode {
  if (typeof window !== 'undefined') {
    try {
      const override = window.localStorage.getItem(STORAGE_KEY);
      if (override === 'binary' || override === '3bucket') return override;
    } catch {
      // localStorage blocked in some sandboxed contexts; fall through.
    }
  }
  return readEnvDefault();
}

export function setConfidenceDisplayMode(
  mode: ConfidenceDisplayMode | null,
): void {
  if (typeof window === 'undefined') return;
  try {
    if (mode === null) {
      window.localStorage.removeItem(STORAGE_KEY);
    } else {
      window.localStorage.setItem(STORAGE_KEY, mode);
    }
  } catch {
    // ignore — flag is best-effort.
  }
}
